import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  user: null,
  token: null,
  guest: false,
  verified: false,
  waitingVerification: false,
  method: null,
  attemps: 0,
};

const slice = createSlice({
  name: 'auth',
  initialState: reHydrateStore('auth') || initialState,
  reducers: {
    setAuth: (state, { payload }) => payload,
    setVerify: (state, { payload }) => ({
      ...state,
      verified: payload,
    }),
    setWaitingVerification: (state, { payload }) => ({
      ...state,
      waitingVerification: payload,
    }),
    setUser: (state, { payload }) => ({
      ...state,
      user: payload,
    }),
    setToken: (state, { payload }) => ({
      ...state,
      token: payload,
    }),
    setAttemps: (state, { payload }) => ({
      ...state,
      attemps: payload,
    }),
    restore: () => initialState,
  },
});

export const {
  setAuth,
  setUser,
  setVerify,
  setToken,
  setAttemps,
  setWaitingVerification,
  restore,
} = slice.actions;

export default slice.reducer;
